// @vendor
const React = require('react');
const PropTypes = require('prop-types');

// @utilities
const { formatText } = require('core/i18n').i18n;

//commons
const OKModal = require('components/commons/OKModal/OKModal');

class RAModifyPlanWarningModal extends React.Component {
    render() {
        const { investProfile, isOpen, onRequestClose } = this.props;
        const descriptionModal = formatText(
            'raModifyPlanWarningModal-raModifyPlanWarningModal_info',
            [investProfile],
        );

        return (
            <OKModal
                description={descriptionModal}
                descriptionAlignment="center"
                footerType="action"
                isOpen={isOpen}
                onCloseCallback={onRequestClose}
                onPrimaryButtonClick={onRequestClose}
                primaryButtonText="raModifyPlanWarningModal-raModifyPlanWarningModal_ctaText"
                shouldCloseOnOverlayClick={false}
                title="raModifyPlanWarningModal-raModifyPlanWarningModal_title"
                titleAlignment="center"
            />
        );
    }
}

RAModifyPlanWarningModal.propTypes = {
    investProfile: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onRequestClose: PropTypes.func.isRequired,
};

module.exports = RAModifyPlanWarningModal;
